import { 
  PRIVATE_ADMIN_ORGCHART, 
  PRIVATE_ADMIN_ORGCHART_VACACIONES, 
  PRIVATE_ADMIN_ORGCHART_EXTRAS,
  PRIVATE_USER_ORGCHART,
  PRIVATE_USER_ORGCHART_VACACIONES,
  PRIVATE_USER_ORGCHART_EXTRAS
} from "../Constants/PathsConstant";
import AdminOrgChartView from "../Views/AdminOrgChartView";
import AdminVacacionesOrgChartView from "../Views/AdminVacacionesOrgChartView";
import AdminExtrasOrgChartView from "../Views/AdminExtrasOrgChartView";

export const OrgChartRouter = [
  {
    path: PRIVATE_ADMIN_ORGCHART,
    element: <AdminOrgChartView />,
    children: []
  },
  {
    path: PRIVATE_ADMIN_ORGCHART_VACACIONES,
    element: <AdminVacacionesOrgChartView />,
    children: []
  },
  {
    path: PRIVATE_ADMIN_ORGCHART_EXTRAS,
    element: <AdminExtrasOrgChartView />,
    children: []
  }
];

export const OrgChartUserRouter = [
  {
    path: PRIVATE_USER_ORGCHART,
    element: <AdminOrgChartView />,
    children: []
  },
  {
    path: PRIVATE_USER_ORGCHART_VACACIONES,
    element: <AdminVacacionesOrgChartView />,
    children: []
  },
  {
    path: PRIVATE_USER_ORGCHART_EXTRAS,
    element: <AdminExtrasOrgChartView />,
    children: []
  }
];
